export default "__VITE_ASSET__BuTdLxNh__"